import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { NgBsToastService } from 'ng-bs-toast-service';
import { Breadcrumb } from '@shared/components';
import { Doctor, DoctorsService } from '../';

@Component({
    selector: 'app-form-doctor',
    standalone: false,
    templateUrl: './form-doctor.component.html',
})
export class FormDoctorComponent implements OnInit {
    ufs = [
        { sigla: 'AC', nome: 'Acre' },
        { sigla: 'AL', nome: 'Alagoas' },
        { sigla: 'AP', nome: 'Amapá' },
        { sigla: 'AM', nome: 'Amazonas' },
        { sigla: 'BA', nome: 'Bahia' },
        { sigla: 'CE', nome: 'Ceará' },
        { sigla: 'DF', nome: 'Distrito Federal' },
        { sigla: 'ES', nome: 'Espírito Santo' },
        { sigla: 'GO', nome: 'Goiás' },
        { sigla: 'MA', nome: 'Maranhão' },
        { sigla: 'MT', nome: 'Mato Grosso' },
        { sigla: 'MS', nome: 'Mato Grosso do Sul' },
        { sigla: 'MG', nome: 'Minas Gerais' },
        { sigla: 'PA', nome: 'Pará' },
        { sigla: 'PB', nome: 'Paraíba' },
        { sigla: 'PR', nome: 'Paraná' },
        { sigla: 'PE', nome: 'Pernambuco' },
        { sigla: 'PI', nome: 'Piauí' },
        { sigla: 'RJ', nome: 'Rio de Janeiro' },
        { sigla: 'RN', nome: 'Rio Grande do Norte' },
        { sigla: 'RS', nome: 'Rio Grande do Sul' },
        { sigla: 'RO', nome: 'Rondônia' },
        { sigla: 'RR', nome: 'Roraima' },
        { sigla: 'SC', nome: 'Santa Catarina' },
        { sigla: 'SP', nome: 'São Paulo' },
        { sigla: 'SE', nome: 'Sergipe' },
        { sigla: 'TO', nome: 'Tocantins' },
    ];
    // No seu componente .ts
    doctorRole: boolean = false; // ou false, conforme o padrão desejado
    title: string;
    doctor = {} as Doctor;
    loading = { main: false, save: false };
    breadcrumb: Breadcrumb[] = [
        // { title: 'Inicio', route: ['/'] },
        { title: 'Médicos', route: ['/doctors'] },
    ];

    constructor(
        private activatedRoute: ActivatedRoute,
        private doctorsService: DoctorsService,
        private toastService: NgBsToastService,
        private router: Router
    ) {}

    ngOnInit() {
        const id = this.activatedRoute.snapshot.paramMap.get('id');
        if (id) {
            this.title = 'Editar Médico';
            this.breadcrumb.push({ title: 'Editar Médico' });
            this.loading.main = true;
            this.doctorsService
                .getById(id)
                .subscribe({
                    next: (res) => (
                        (this.doctor = res),
                        (this.doctorRole = res.role === 'ARIEL_ADMIN')
                    ),
                    error: (err: HttpErrorResponse) =>
                        this.toastService.send(
                            `Erro ${err.status}`,
                            err.error.message || err.message,
                            'danger'
                        ),
                })
                .add(() => (this.loading.main = false));
        } else {
            this.title = 'Novo Médico';
            this.breadcrumb.push({ title: 'Novo Médico' });
        }
    }

    saveDoctor() {
        this.loading.save = true;

        this.doctor.role = this.doctorRole ? 'ARIEL_ADMIN' : 'ARIEL_DOCTOR';

        const request = this.doctor.id
            ? this.doctorsService.update(this.doctor)
            : this.doctorsService.create(this.doctor);

        request
            .subscribe({
                next: () => {
                    this.router.navigate(['/doctors']);
                    this.toastService.send(
                        'Sucesso',
                        'Médico salvo com sucesso!',
                        'success'
                    );
                },
                error: (err: HttpErrorResponse) =>
                    this.toastService.send(
                        `Erro ${err.status}`,
                        err.error.message || err.message,
                        'danger'
                    ),
            })
            .add(() => (this.loading.save = false));
    }
}
